import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Joyride, STATUS, ACTIONS } from "react-joyride";

const STEPS = [
  {
    target: ".kpi-section",
    content: "Qui trovi i tuoi numeri a colpo d'occhio: fatturato, incassi, netto disponibile e tasse da accantonare.",
    disableBeacon: true,
  },
  {
    target: "[data-tour='nav-invoices']",
    content: "Gestisci le tue fatture: crea, modifica, importa da CSV e tieni traccia degli incassi.",
    placement: "right",
  },
  {
    target: "[data-tour='nav-fiscal']",
    content: "Configura il tuo regime fiscale: codice ATECO, aliquota, contributi INPS e scadenze.",
    placement: "right",
  },
  {
    target: "[data-tour='nav-simulazioni']",
    content: "Simula scenari fiscali: verifica la soglia 85k e calcola le tasse su fatturati ipotetici.",
    placement: "right",
  },
  {
    target: "[data-tour='nav-settings']",
    content: "Personalizza il tuo profilo: nome, logo e formato numero fattura.",
    placement: "right",
  },
  {
    target: ".setup-checklist",
    content: "Completa questi passi per configurare Forfy al meglio per la tua attività.",
  },
  {
    target: "body",
    placement: "center",
    content: "Sei pronto! Buon lavoro con Forfy. Puoi sempre consultare i tooltip (?) per aiuto.",
  },
];

export default function GuidedTour({ darkMode, appSettings, updateAppSettings }) {
  const location = useLocation();
  const [run, setRun] = useState(false);
  const [steps, setSteps] = useState(STEPS);

  useEffect(() => {
    if (
      location.pathname === "/dashboard" &&
      appSettings.tourCompleted !== true
    ) {
      const timer = setTimeout(() => {
        // Filtra step il cui target non è nel DOM (es. mobile: sidebar hidden)
        const availableSteps = STEPS.filter((s) => {
          if (s.target === "body") return true;
          return document.querySelector(s.target) !== null;
        });
        if (availableSteps.length > 0) {
          setSteps(availableSteps);
          setRun(true);
        }
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [location.pathname, appSettings.tourCompleted]);

  const handleCallback = (data) => {
    const { action, status } = data;
    const finishStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
    if (action === ACTIONS.CLOSE || finishStatuses.includes(status)) {
      setRun(false);
      updateAppSettings({ tourCompleted: true });
      setTimeout(() => {
        document.querySelectorAll(
          '.react-joyride__spotlight, .react-joyride__overlay, .react-joyride__beacon, [data-test-id="overlay"]'
        ).forEach((el) => el.remove());
      }, 150);
    }
  };

  if (!run) return null;

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showSkipButton
      disableScrollParentFix
      scrollToFirstStep={false}
      disableOverlayClose
      floaterProps={{ disableFlip: true }}
      callback={handleCallback}
      locale={{
        back: "Indietro",
        close: "Chiudi",
        last: "Fine",
        next: "Avanti",
        skip: "Salta",
      }}
      styles={{
        options: {
          primaryColor: "#E67A52",
          zIndex: 10000,
          arrowColor: darkMode ? "#262626" : "#fff",
          backgroundColor: darkMode ? "#262626" : "#fff",
          textColor: darkMode ? "#e5e5e5" : "#171717",
        },
        tooltip: {
          borderRadius: 12,
          fontFamily: "inherit",
        },
        buttonNext: {
          borderRadius: 8,
          fontFamily: "inherit",
        },
        buttonBack: {
          color: darkMode ? "#a3a3a3" : "#525252",
          fontFamily: "inherit",
        },
        buttonSkip: {
          color: darkMode ? "#737373" : "#a3a3a3",
          fontFamily: "inherit",
        },
      }}
    />
  );
}
